// extracted by mini-css-extract-plugin
export default {"productDescription":"f9eb2f791dba"};